export default __webpack_public_path__ + "static/media/50.11009d49.svg";